import React from 'react';

export default function VideoOnIcon() {
	return (
		<svg width="20" height="20" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M31 20.0765V11.2598C31 9.77646 29.2 9.02646 28.15 10.0765L24.3333 13.9098V8.07646C24.3333 7.1598 23.5833 6.4098 22.6667 6.4098H13.3167L28.1667 21.2598C29.2 22.3098 31 21.5598 31 20.0765ZM0.516675 0.676465C-0.133325 1.32646 -0.133325 2.37647 0.516675 3.02646L3.88334 6.4098H2.66667C1.75001 6.4098 1.00001 7.1598 1.00001 8.07646V24.7431C1.00001 25.6598 1.75001 26.4098 2.66667 26.4098H22.6667C23.0167 26.4098 23.3167 26.2765 23.5833 26.1098L27.7167 30.2431C28.3667 30.8931 29.4167 30.8931 30.0667 30.2431C30.7167 29.5931 30.7167 28.5431 30.0667 27.8931L2.86667 0.676465C2.21667 0.0264648 1.16667 0.0264648 0.516675 0.676465Z"
				fill="red"
			/>
		</svg>
	);
}
